import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/caret_left.svg'
import _imports_1 from '@/assets/icons/caret_right.svg'


const _withScopeId = n => (_pushScopeId("data-v-43ed34be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-wrapper" }
const _hoisted_2 = { class: "year-month" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  ref: "calendarContents",
  class: "calendar-contents"
}
const _hoisted_8 = { class: "day-of-week-wrapper" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "월", -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "화", -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "수", -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "목", -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "금", -1 /* HOISTED */))
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "days-wrapper" }
const _hoisted_17 = ["id", "onClick"]
const _hoisted_18 = { class: "day-title" }
const _hoisted_19 = {
  key: 0,
  class: "calendar-label"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "event-color" }, null, -1 /* HOISTED */))
const _hoisted_21 = { class: "event-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn prev",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changeMonth(false))),
        "aria-label": "이전 달 선택"
      }, [..._hoisted_4]),
      _createElementVNode("p", null, _toDisplayString($setup.year) + ". " + _toDisplayString($setup.formattedMonth), 1 /* TEXT */),
      _createElementVNode("button", {
        class: "btn next",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeMonth(true))),
        "aria-label": "다음 달 선택"
      }, [..._hoisted_6])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("section", _hoisted_8, [
        ($setup.shouldShowSunday)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "일"))
          : _createCommentVNode("v-if", true),
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        ($setup.shouldShowSaturday)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, "토"))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("section", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dates, (date, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["day-wrapper", { selected: date.format('YYYY-MM-DD') === $setup.selectedDate }]),
            key: index,
            id: `day-wrapper-${index}`,
            onClick: ($event: any) => ($setup.onClickDay(date))
          }, [
            _createElementVNode("p", _hoisted_18, _toDisplayString($setup.dayjs(date).format("D")), 1 /* TEXT */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.eventList, (event, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: `${event.date}${index}`
              }, [
                (event.date === date.format('YYYY-MM-DD'))
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(event.eventTitles, (eventTitle, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        ($props.displayMode === $setup.CalendarDisplayMode.Chip)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              class: _normalizeClass(["event chip", [$setup.getEventColorClass(eventTitle)]])
                            }, _toDisplayString(eventTitle), 3 /* TEXT, CLASS */))
                          : _createCommentVNode("v-if", true),
                        ($props.displayMode === $setup.CalendarDisplayMode.Bar)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.getCountEvent(eventTitle), (cnt) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: cnt,
                                class: _normalizeClass(["event bar", [$setup.getEventColorClass(eventTitle)]])
                              }, null, 2 /* CLASS */))
                            }), 128 /* KEYED_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ], 10 /* CLASS, PROPS */, _hoisted_17))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      ($props.displayMode === $setup.CalendarDisplayMode.Bar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.eventColorClassMap?.keys(), (eventTitle, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass($setup.getEventColorClass(eventTitle))
              }, [
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, _toDisplayString(eventTitle), 1 /* TEXT */)
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ], 512 /* NEED_PATCH */),
    ($setup.calendarContents)
      ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
          key: 0,
          container: $setup.calendarContents
        }, null, 8 /* PROPS */, ["container"]))
      : _createCommentVNode("v-if", true)
  ]))
}